import api, { BASE_URL } from '../../utils/apiService/apiService';
import { EnrollmentStep } from './enrollmentModel';

export const BULK_TEMPLATE_URL: string = `${BASE_URL}/bulk/template`;

const enrollmentApi = {
  createEnrollment: (userId: string) => {
    const request = api.post('enrollments', {
      userId,
    });
    return request;
  },
  getLatestEnrollment: (userId: string) => {
    const request = api.get(`enrollments/user/${userId}/latest`);
    return request;
  },
  enroll: (enrollmentId: string) => {
    const request = api.post('enrollments/enroll', {
      enrollmentId,
    });
    return request;
  },
  saveStep: (
    enrollmentId: string,
    stepName: EnrollmentStep,
    stepData: string
  ) => {
    const request = api.post(`enrollments/${enrollmentId}/steps`, {
      stepName,
      stepData,
    });
    return request;
  },
  updateStep: (
    enrollmentId: string,
    stepId: string,
    stepName: EnrollmentStep,
    stepData: string
  ) => {
    const request = api.put(`enrollments/${enrollmentId}/steps/${stepId}`, {
      stepName,
      stepData,
    });
    return request;
  },
  uploadTemplateFile: (enrollmentId: string, file: File) => {
    const formData = new FormData();
    formData.append('enrollmentId', enrollmentId);
    formData.append('file', file);

    const request = api.post('bulk/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return request;
  },
  getEdgarStatus: () => {
    const request = api.get('enrollments/status');
    return request;
  },
  getEnrollmentSteps: (enrollmentId: string) => {
    const request = api.get(`enrollments/${enrollmentId}/steps`);
    return request;
  },
};

export default enrollmentApi;
